import { formatDevBuildLabel } from '@aira/shared';

function env(name: string): string | undefined {
  const fromProcess = typeof process !== 'undefined' ? process.env?.[name] : undefined;
  if (fromProcess !== undefined) return fromProcess;
  return (import.meta.env as Record<string, string | undefined>)[name];
}

export function getDevBuildLabel(): string | null {
  return formatDevBuildLabel({
    env: env('VITE_DEPLOY_ENV'),
    enabled: env('VITE_SHOW_DEV_BUILD_LABEL'),
    sha: env('VITE_BUILD_SHA'),
    builtAt: env('VITE_BUILD_TIME'),
  });
}
